<div class="main-content">
     <div class="title">
        <h2>The Daily Crunch: Dry fruits and Nuts</h2>
    </div>
    <div class="content">
        <!-- <div class="contact-details"> -->
            <span>Contact us: </span>
            <div class="phone-number">
                <img src="../assets/icons/mobile2.png">
                <a href="tel:+91-6304047464">6304047464</a>
            </div>
            <div class="mail">
                <img src="../assets/icons/mail2.png">
                <a href="mailto:srikanthdokku007@gmail.com">srikanthdokku007@gmail.com</a>
            </div>
        <!-- </div> -->
    </div>
    <div class="nav-bar">
        <div class="moving-text">
            🎉 Get a discount on your first delivery! • 🚚 Delivery is available throughout Andhra Pradesh and Telangana • Shop Fresh Dry Fruits Now! • 🎉 Get a discount on your first delivery! • 🚚 Delivery is available throughout Andhra Pradesh and Telangana •
        </div>
    </div>
</div>